import { render } from "./loginAdmin.vue?vue&type=template&id=627e1852"
import script from "./loginAdmin.vue?vue&type=script&lang=js"
export * from "./loginAdmin.vue?vue&type=script&lang=js"

import "./loginAdmin.vue?vue&type=style&index=0&id=627e1852&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__